import * as React from "react";
import PropTypes from "prop-types";

import MuiTextField from "@mui/material/TextField";

function TextField(props) {
  return <MuiTextField {...props} />;
}

TextField.propTypes = {
  label: PropTypes.string,
  value: PropTypes.any,
  onChange: PropTypes.func,
};

export default TextField;
